//noScroll
class HeaderAdjust {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    var topHeader = document.querySelector(".top-header");
    if (topHeader) {
        document.querySelector('.js-megaMenu_shop').classList.add("is-topPage");
        topHeader.classList.add("is-topPage");
        document.querySelector(".l-header__menu").classList.add("is-block");
        const megaTrigger = document.querySelectorAll(".js-megaTrigger-click");
        megaTrigger.forEach(function(el) {
          el.classList.add("is-topPage");
        });
        document.querySelector(".mega-Service").classList.add("is-topPage");
        document.querySelector(".mega-tel").classList.add("is-topPage");
        document.querySelector(".mega-line").classList.add("is-topPage");
        document.querySelector(".header-contact").classList.add("is-topPage");
    }
  }
}